import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const icims = defineConnector({
  identifier: "icims",
  name: "iCIMS",
  tagLine: "Talent acquisition platform",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://.*\\.icims\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Get your iCIMS API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Contact your iCIMS administrator to obtain API credentials. You'll need your customer ID, client ID, and client secret from the iCIMS developer portal.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Customer ID",
          required: true,
          placeholder: "12345",
          target: { kind: "configuration", field: "customerId" },
          helperText: "Your iCIMS customer ID.",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://login.icims.com/oauth/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ customerId }) =>
      `https://api.icims.com/customers/${customerId}/search/people`,
  },
});
